<div class="records-page reports-page">
    <div class="reports-page__header">
        <div class="dv-custom-navs reports-navs">
            <ul class="nav-tabs reports-nav-tabs">
                <li class="nav-item" [class.rm-tab-active]="active === 1">
                    <button type="button" class="nav-link" [class.active]="active === 1" (click)="selectTab('campaign-report', 1)">
                        <i-feather name="check"></i-feather><label>{{ 'CAMPAIGN_REPORT' | translate }}</label>
                    </button>
                </li>
                <li class="nav-item" [class.rm-tab-active]="active === 2">
                    <button type="button" class="nav-link" [class.active]="active === 2" (click)="selectTab('rollup-report', 2)">
                        <i-feather name="file-text"></i-feather><label>{{ 'ROLLUP_REPORT' | translate }}</label>
                    </button>
                </li>
                <li class="nav-item" *ngIf="isAdmin" [class.rm-tab-active]="active === 3">
                    <button type="button" class="nav-link" [class.active]="active === 3" (click)="selectTab('weekly-reports', 3)">
                        <i-feather name="file-text"></i-feather><label>{{ 'WEEKLY_REPORTS' | translate }}</label>
                    </button>
                </li>
                <li class="nav-item" *ngIf="hasBrandDashboardAccess" [class.rm-tab-active]="active === 4">
                    <button type="button" class="nav-link" [class.active]="active === 4" (click)="selectTab('brand-report', 4)">
                        <i-feather name="file-text"></i-feather><label>{{ 'BRAND_DASHBOARD' | translate }}</label>
                    </button>
                </li>
            </ul>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>